import { render, staticRenderFns } from "./BodegaReporteCodigosSeries.vue?vue&type=template&id=2404effa"
import script from "./BodegaReporteCodigosSeries.vue?vue&type=script&lang=js"
export * from "./BodegaReporteCodigosSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports